// Per-challenge leaderboard: you vs the friends who joined this code, ranked
// by GM Score. Phase 1 runs on the local stub backend, so the board usually
// holds just this device's entry — the UI shows a "waiting on your group"
// state around it. Phase 2 swaps in the real per-code fetch.

import { helpers } from "../util/index.ts";
import type { UpdateEvents } from "../../common/types.ts";
import * as challengeBackend from "../util/challengeBackend/index.ts";
import type { ChallengeEntry } from "../util/challengeBackend/index.ts";
import getChallenge from "../core/league/getChallenge.ts";

const updateChallengeLeaderboard = async (
	inputs: unknown,
	updateEvents: UpdateEvents,
) => {
	if (
		updateEvents.includes("firstRun") ||
		updateEvents.includes("newPhase") ||
		updateEvents.includes("gameAttributes")
	) {
		const ch = getChallenge();
		if (!ch) {
			return { redirectUrl: helpers.leagueUrl([]) };
		}

		let entries: ChallengeEntry[] = [];
		try {
			entries = await challengeBackend.getLeaderboard(ch.code);
		} catch {
			// Offline — fall through to the local entry.
		}
		if (ch.result && !entries.some((e) => e.playerId === ch.playerId)) {
			entries.push({
				code: ch.code,
				playerId: ch.playerId,
				gmScore: ch.result.gmScore,
				grade: ch.result.grade,
				draftPick: ch.result.draftPick,
				wins: ch.result.wins,
				losses: ch.result.losses,
			});
		}
		entries.sort((a, b) => b.gmScore - a.gmScore);

		return {
			code: ch.code,
			playerId: ch.playerId,
			status: ch.status,
			rows: entries.map((e, i) => ({
				rank: i + 1,
				playerId: e.playerId,
				grade: e.grade,
				gmScore: e.gmScore,
				wins: e.wins,
				losses: e.losses,
				isMe: e.playerId === ch.playerId,
			})),
		};
	}
};

export default updateChallengeLeaderboard;
